export default "__VITE_ASSET__e5a68db7__"